(function () {
  if (!('IntersectionObserver' in window)) {
    document.querySelectorAll('[data-animate]').forEach(function (el) {
      el.classList.add('is-visible');
    });
    return;
  }

  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.1 }
  );

  function observe(root) {
    root.querySelectorAll('[data-animate]').forEach(function (el) {
      observer.observe(el);
    });
  }

  observe(document);

  document.addEventListener('shopify:section:load', function (event) {
    observe(event.target);
  });
})();
